"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTargetOrigin = exports.validateAttributes = void 0;
function validateAttributes(properties) {
    if (!properties.src) {
        throw new Error("src is required");
    }
    if (typeof properties.src !== "string" ||
        !properties.src.match(/.*\/embed\/applications\/.*/) ||
        properties.src.match(/.*\/embed\/applications\/edit\/.*/)) {
        throw new Error("src is not a valid Superblocks embed url");
    }
    if (properties.id !== undefined && typeof properties.id !== "string") {
        throw new Error("id must be a string");
    }
    if (properties.token !== undefined && typeof properties.token !== "string") {
        throw new Error("token must be a string");
    }
    if (properties.onAppLoaded !== undefined &&
        typeof properties.onAppLoaded !== "function") {
        throw new Error("onAppLoaded must be a function");
    }
    if (properties.onNavigation !== undefined &&
        typeof properties.onNavigation !== "function") {
        throw new Error("onNavigation must be a function");
    }
    if (properties.onAuthError !== undefined &&
        typeof properties.onAuthError !== "function") {
        throw new Error("onAuthError must be a function");
    }
    if (properties.onEvent !== undefined &&
        typeof properties.onEvent !== "function") {
        throw new Error("onEvent must be a function");
    }
    if (properties.properties !== undefined &&
        (typeof properties.properties !== "object" ||
            Array.isArray(properties.properties))) {
        throw new Error("properties must be an object");
    }
    if (properties.colorScheme !== undefined &&
        (typeof properties.colorScheme !== "string" ||
            !["light", "dark"].includes(properties.colorScheme))) {
        // not a breaking error, but we should log it
        console.error("colorScheme must be either 'light' or 'dark'");
    }
}
exports.validateAttributes = validateAttributes;
function extractTargetOrigin(src) {
    if (!src)
        return "*";
    const url = new URL(src);
    return url.origin;
}
exports.extractTargetOrigin = extractTargetOrigin;
